var app = angular.module('leonardo');

var SectorRestService = function(BaseRestService) {
  return new BaseRestService('sectors');
};

app.factory('SectorRestService', ['BaseRestService', SectorRestService]);
